import React, { createContext, useContext, useState, useEffect } from "react";

const PointsContext = createContext();

export function PointsProvider({ children }) {
  const [points, setPoints] = useState(0);
  const [loginCount, setLoginCount] = useState(0);
  const [messageCount, setMessageCount] = useState(0);

  // (Example: restore counts from localStorage or start from 0)
  useEffect(() => {
    setPoints(Number(localStorage.getItem("nia_points") || 0));
    setLoginCount(Number(localStorage.getItem("nia_loginCount") || 0));
    setMessageCount(Number(localStorage.getItem("nia_messageCount") || 0));
  }, []);

  // (Optional: update localStorage when changed)
  useEffect(() => {
    localStorage.setItem("nia_points", points);
    localStorage.setItem("nia_loginCount", loginCount);
    localStorage.setItem("nia_messageCount", messageCount);
  }, [points, loginCount, messageCount]);

  return (
    <PointsContext.Provider value={{
      points, setPoints,
      loginCount, setLoginCount,
      messageCount, setMessageCount
    }}>
      {children}
    </PointsContext.Provider>
  );
}

export function usePoints() {
  return useContext(PointsContext);
}
